import { initialTerminalChangelogState } from "./ChangelogState";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import { TerminalLogFilterModel } from "../../app/data/terminal-details/models";
import terminalChangelogService from "../../app/data/terminal-details/terminalChangelogService";
import { IState } from "..";

const terminalService = terminalChangelogService;

export const terminalChangelogSlice = createSlice({
  name: "terminalChangelog",
  initialState: initialTerminalChangelogState,
  reducers: {
    resetTerminalChangelogState: (state) => initialTerminalChangelogState,
    requestStarted: (state, { payload }) => {
      if (payload === "GET_TERMINALS_LOG_PORTION") {
        state.fetchPortionStarted = true;
      } else {
        state.requestStarted = true;
      }
      state.requestSucceed = false;
      state.requestFailed = false;
      state.requestCreator = payload;
      state.requestError = "";
    },
    requestSucceed: (state) => {
      state.requestStarted = false;
      state.requestSucceed = true;
      state.requestFailed = false;
    },
    requestFailed: (state, { payload }) => {
      state.requestStarted = false;
      state.requestSucceed = false;
      state.requestFailed = true;
      state.requestFailStatus = payload.status;
      state.requestError = payload.error;
    },
    setTerminalLog: (state, { payload }) => {
      state.terminalLog = payload;
    },
    addTerminalLog: (state, { payload }) => {
      state.terminalLog = [...state.terminalLog, ...payload];
    },
    clearTerminalLog: (state) => {
      state.terminalLog = [];
    },
    setTerminalLogRequest: (state, { payload }) => {
      state.terminalLogRequest = {
        page: payload.page,
        last: payload.last
      };
    },
  }
});

export const {
  resetTerminalChangelogState,
  requestStarted,
  requestSucceed,
  requestFailed,
  setTerminalLog,
  addTerminalLog,
  clearTerminalLog,
  setTerminalLogRequest,
} = terminalChangelogSlice.actions;

export const terminalChangelogSelector = (state: IState) => {
  return state.terminalChangelog;
};


export const getTerminalsLog = (
  terminalNumber: string,
  filter: TerminalLogFilterModel,
  page?: number
): AppThunk => async (dispatch) => {
  dispatch(requestStarted(page ? "GET_TERMINALS_LOGS_PORTION" : "GET_TERMINALS_LOG"));
  const response = await terminalService.getTerminalsLog(terminalNumber, filter, page);
  if (response.isCancel?.()) return;
  if (response.ok()) {
    dispatch(page ? addTerminalLog(response.data?.content) : setTerminalLog(response.data?.content));
    dispatch(setTerminalLogRequest({
      page: response.data?.pageable.pageNumber,
      last: response.data?.last
    }));
    dispatch(requestSucceed());
  } else {
    dispatch(requestFailed(response.getError ? response.getError() : "Error"));
  }
};
const terminalChangeLogReducer = terminalChangelogSlice.reducer;
export default terminalChangeLogReducer;